
import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0,0)`)
      .attr('font-family', 'roboto')
     
      this.canvasForms
      .append('rect')
      .attr('x', 0).attr('y', 1110)
      .attr('width', 1600).attr('height', 10)
      .attr('fill', '#D71638')
      
      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/TrionFPU_r1.svg')
      .attr('x', 30).attr('y', 30).attr('width', 230)

      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + '/Visualization/Layout_LQ/Keyplan.svg')
      .attr('x', 30).attr('y', 140).attr('width', 250)


      this.canvasForms
      .append('text')
      .attr('transform', `translate(30, 108)`)
      .attr('font-size', 24)
      .attr('fill', '#000')
      .text('LQ Room Layout')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(30, 125)`)
      .attr('font-size', 12)
      .attr('fill', '#44A9DF')
      .text(this.rawData.SUB_TITLE)
    

      this.draw_Layout()
    },

  }
}